import {Component, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  EditService, IFilter, PageService, RowSelectEventArgs, SelectionSettingsModel, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { Observable } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap';
import { MysqlService } from '../../../services/mysql.service';
import { Brand } from './../../../shared/models/brand.model';
import { SubjectInvoiceItem } from './../../../shared/models/subjectInvoiceItem.model';
import { MyobServiceInvoice } from './../../../models/myob-service-invoice.model';
import { SubjectInvoice } from './../../../shared/models/subjectInvoice.model';
import { ClientInvoiceBulkPaymentWidgetComponent } from './../../../components/invoices/client-invoice-bulk-payment-widget/client-invoice-bulk-payment-widget.component';
import { SubjectWorkOrder } from './../../../shared/models/subjectWorkOrder.model';
import { SubjectWorkOrderItem } from './../../../shared/models/subjectWorkOrderItem.model';
import { WorkOrderBulkPaymentWidgetComponent } from './../../../components/work-orders/work-order-bulk-payment-widget/work-order-bulk-payment-widget.component';
import { SearchPayment } from 'src/app/shared/models/searchPayments.model';


@Component({
  selector: 'app-brand-work-orders-grid',
  templateUrl: './brand-work-orders-grid.component.html',
  styleUrls: ['./brand-work-orders-grid.component.css'],
  providers: [EditService, ToolbarService, PageService, FilterService]
})
export class BrandWorkOrdersGridComponent implements OnInit {



  @Input() brand_id?; 
  @Input() job_status_code?; 
  @Input() assigned_agent?;  // single agent brand_id lookup
  
  @Input() job_id?;
  @Input() subject_id?; 
  
     // setup as observable?
     @Input() item_id?; // impliments on changes. // Base set to Job_ID
     @Input() item_data?: Observable<SubjectInvoice[]>; // if data.model is sent ;

    @Input() item_data2?: SubjectInvoice; // if data.model is sent ;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = null;
     @Input() item_brand_id? = null;
     @Input() item_subject_id? = null;
     @Input() item_subject_number? = '';
     
     @Input() show_buttons? = 'no'; // yes | no
     @Input() item_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full
  
   // Grid Vars
   public data: DataManager;
   public data_subjects: DataManager;
   public pageSettings: Object;
   public pageOptions = { pageSize: 600 }; 
   public filterOptions: FilterSettingsModel;
   public formatOptions: Object;
   // public filterOptions: FilterSettingsModel;
   public filter : IFilter;
   public toolbarOptions: ToolbarItems[];
   @ViewChild('grid')
   public grid: GridComponent;
   public groupOptions: GroupSettingsModel;
   public templateOptionsDate: IFilterUI;
   public elem1: HTMLElement;
   public datePickerObj: DatePicker;
   subjects_urgent: any;
   formatoptions: { type: string; format: string; };
   dateFormat: string;
   sortOptions: { columns: { field: string; direction: string; }[]; };
   
   today = new Date().toISOString(); // this date worked to compare dates with ZISo date format in database.
   // today_set = new Date(); // sets todays date
   // today = this.datepipe.transform(this.today_set, 'dd/MM/yyyy h:mm a'); // formats date for comparison
  
   initialPage: { pageSize: number; };
   open_jobs_count: any;
    all_router_details: string;
    sessionUserId: any;
    sessionUsername: any;
    sessionBrandId: any;
    invoices: any;
    modalRef: any;
    myobInvoiceCreatedData: any;
    myobInvoiceListMapped: any;
    set_RowVersion: any;
    brand: any;
    brandData: any;
    data_invoice: any = MyobServiceInvoice;
    myobInvoices: Object;
    arrCase: object[];
    Items: any;
    myobInvoiceDeleteData: Object;
    myobInvoice: Object;
    invoiceItem: any;
    invoiceItemsList: any = SubjectInvoiceItem;
    
    myob_account_codes: Object;
    myob_tax_codes: Object;
    myobInvoiceUpdateData: any;
    myobInvoiceUpdatedData: any;
  
    // invoice_model: SubjectInvoice = new SubjectInvoice();
    invoice_model:any = SubjectInvoice;
    invoice_item_model: any = SubjectInvoiceItem;
    invoiceItemUpdateList: any;
    new_line: {};

    work_order_model:any = SubjectWorkOrder;
    work_order_item_model: any = SubjectWorkOrderItem;
    workOrderItemUpdateList: any;
  work_orders: Object;


  isShow_search = false;
  isShow_quickSearch= false;
  // search_model: SubjectWorkOrder;
  
  public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' }; // using the name field not id!
  client_fields: Object = { text: 'user_full_name', value: 'user_id' };
  brands_agent: any;
  work_order_status_all: any;
  work_order_payment_status_all: any;
  work_order_communication_status_all: any;

  search_model: SearchPayment;
  join_results: any[];
  payments_search: Object;
  payments_search_results: any;
  work_orders_to_pay_array: any[];
  public selectionOptions: SelectionSettingsModel;
  // search_results: any;
   @Input() search_results: any;

  selectedrecords: object[];
  public wrapSettings: TextWrapSettingsModel; // this allows the content to wrap only Header|Content|Both
  @Output('rowDeselected') rowDeselected: EventEmitter<any> = new EventEmitter();
  

    constructor(private http: HttpClient, private router: Router,
      private route: ActivatedRoute, private _demoService: DemoService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     private modalService: BsModalService,
     public toastr: HotToastService,
     vcr: ViewContainerRef,
     private _mysqlService: MysqlService,
    //  public cIBP: ClientInvoiceBulkPaymentWidgetComponent,
     public _WorkOrderBulkPaymentWidgetComponent: WorkOrderBulkPaymentWidgetComponent
     ) { 
  
       // Set and Access login Session Variables
   this.gfunc.setLoginSessionVars(); // set in a global function file
   this.sessionUserId = this.gfunc.currentUserVAR.user_id;
   this.sessionUsername = this.gfunc.currentUserVAR.username;
   this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
  
        // need to add this as routes does not work globally
        this.all_router_details = this.router.url;
        this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
  
      // Grid Options
      this.toolbarOptions = ['Search'];
      this.initialPage = { pageSize: 40 };
      this.filterOptions = {
         type: 'Menu'
      };
  
    // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
      this.groupOptions = { }; // sets auto grouping for the grid
  
      this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
      this.dateFormat = 'dd/MM/yyyy hh:mm a';
       //this.filter = { params: { format: this.dateFormat } };
      this.sortOptions = { columns: [{ field: 'work_order_number', direction: 'Ascending' } ] };
      this.wrapSettings = { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both
      
      
      
      this.selectionOptions = {type: 'Multiple', checkboxOnly: true,}; // type: 'Multiple', mode: 'Both // checkboxMode: 'ResetOnRowClick'
      // this.selectionOptions = { mode: 'Row',  type: 'Single' }; // sept 24 build SO20_33
  
      

     }
  
    ngOnInit() {
      // this.getInvoices();
      this.getMyobTaxCodes(); // load for merge variables arrays
      this.getMyobAccountCodes();
  
      this.getWorkOrderStatusAll();
      this.getWorkOrderPaymentStatusAll();
      this.getWorkOrderCommunicationStatusAll();

      // this.getBrandWorkOrders(this.brand_id);// ofiginal
         // this.search_model = new SubjectInvoice(); 
  
         // staff
if(this.gfunc.sessionBrandTypeId == 1){
 this.search_model.to_brand_id = this.brand_id;
         this.search_model.work_order_payment_status_id = 1; // FIrst Load Outstanding Payments Only
         this.search_model.myob_sync_status = 2; // already in myob
         this.getWorkOrdersSearch(this.search_model)
}

//agent
if(this.gfunc.sessionBrandTypeId == 3){
       this.getBrandWorkOrders(this.brand_id);// ofiginal

}    

         
      
    }
  
    ngOnChanges(changes) {

      
 
      if (changes.brand_id) {
        // deal with asynchronous Observable result
    this.brand_id = changes.brand_id.currentValue;
    // this.getBrandWorkOrders(this.brand_id); // Original

  // staff
  if(this.gfunc.sessionBrandTypeId == 1){
    this.search_model = new SubjectWorkOrder();
    // this.getPaymentsSearch(this.search_model);

    // Can setup some model defaults here If I like so to preload... etc.... this.search_model.variable = etc...
    this.search_model.to_brand_id = this.brand_id;
    this.search_model.work_order_payment_status_id = 1; // FIrst Load Outstanding Payments Only
    this.search_model.myob_sync_status = 2; // already in myob


        this.getBrandsComboBoxAgents(this.search_model);
        // this.getInvoiceStatusAll();
        // this.getInvoicePaymentStatusAll();
        // this.getInvoiceCommunicationStatusAll();

        this.getWorkOrderStatusAll();
        this.getWorkOrderPaymentStatusAll();
        this.getWorkOrderCommunicationStatusAll();

    this.getWorkOrdersSearch(this.search_model); 

  }

          // agent -- can run the search or do original
  if(this.gfunc.sessionBrandTypeId == 3){

            // this.search_model = new SubjectInvoice();
                // this.search_model.to_brand_id = this.brand_id;
                // this.search_model.work_order_payment_status_id = 1; // FIrst Load Outstanding Payments Only
                // this.search_model.myob_sync_status = 2; // already in myob
                // this.getWorkOrdersSearch(this.search_model)
  
            
               this.getBrandWorkOrders(this.brand_id); // Original

          }



      }

     
      // sent invoice data array
  if (changes.item_data) {
    // all this not working
    // this.invoices = this.cIBP.invoicePaymentItemsList;
        // deal with asynchronous Observable result
    this.item_data = changes.item_data.currentValue;
    // grid content moddl - load
    // this.invoices = this.item_data;
    // this.getBrandInvoices(this.brand_id);
      }

  // this.getInvoices();
      if (changes.subject_id) {
        // deal with asynchronous Observable result
    this.subject_id = changes.subject_id.currentValue;
  //  this.getSubjectInvoices(this.subject_id);
    //  this.getBrandJobsTableDataGrid(this.brand_id, this.job_status_code, this.assigned_agent);
  };
   // this.getInvoices();
  
    };
  
  

    getWorkOrdersSearch(search_model) {
      this.work_orders = [];
      this.join_results = [];
      search_model.brand_type_id = 0;
      search_model.access_level = 0;
      this._demoService.getWorkOrdersSearch(search_model).subscribe(
        data => { this.payments_search = data;
          // pass so that the dates are correct in Sync
          // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
          this.payments_search_results = DataUtil.parse.parseJson(data);
  
  
          // get the users as well and join the records together
          //  this.getReportUsersSearch(search_model);
  
    // now how to join two arrays of objects.
    // maybe pass results in to a new model.
  
                // Count items of brand search to loop through
                let  count_of_payment_items = Object.keys(this.payments_search).length;
                // now loop and push to join model
                for(let i=0;i < count_of_payment_items; i++) {
                  let res = this.payments_search_results[i];
  
                 let current_invoice_id = this.payments_search_results[i].invoice_id;
                 if(current_invoice_id == null) {
                  // this.payments_search_results[i].to_brand_name = 'NO_SUPPLIER_INVOICE_';
                 }
  
                    // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
                    this.join_results.push({
                     ...this.payments_search_results[i]
                            });
  
                } // end brands loop.
  
  
                // this.join_results = this.join_results;

      
  
                this.grid.refresh();
  
  // Works well
          // let filtered_results =   this.join_results.filter(function(responseData) {
          //   return responseData.work_order_id !== null;
          // });
          //  this.join_results = filtered_results;
  
  // Payments need to be
  // invoice_status = approved
  // invoice_payment_status != PAID
  
  
  // Calculate some numbers
            // this.total_work_orders_paid = this.join_results.length;
            // this.total_work_orders_paid_amount = this.join_results.filter((item) => item.work_order_total)
            // .map((item) => +item.work_order_total)
            // .reduce((sum, current) => sum + current);
            // this.total_work_orders_to_pay = this.join_results.filter((item) => item.work_order_id && item.work_order_payment_status_id !== '2')
            // .map((item) => +item.work_order_id).length;
            // // tslint:disable-next-line:max-line-length
            // this.total_work_orders_to_pay_amount = this.join_results.filter((item) => item.work_order_total && item.work_order_payment_status_id !== '2')
            // .map((item) => +item.work_order_total)
            // .reduce((sum, current) => sum + current);
            // this.total_work_orders_already_paid = this.join_results.filter((item) => item.work_order_id && item.work_order_payment_status_id === '2')
            // .map((item) => +item.work_order_id).length;
            // // tslint:disable-next-line:max-line-length
            // this.total_work_orders_already_amount = this.join_results.filter((item) => item.work_order_total && item.work_order_payment_status_id === '2')
            // .map((item) => +item.work_order_total)
            // .reduce((sum, current) => sum + current);
            // this.total_work_orders_not_yet_generated = this.join_results.filter((item) => item.work_order_id && item.work_order_id === null)
            // .map((item) => +item.work_order_id).length;
  
            // this.work_orders_to_pay_array = this.join_results.filter((item) => item.work_order_id && item.work_order_payment_status_id !== '2')
            // .map((item) => +item.work_order_id);
            // tslint:disable-next-line:max-line-length
            // let work_orders_to_pay_array = Object(this.join_results).filter((item)=>(item.work_order_payment_status_id !== '2')); // User this if filter is needed.
            this.work_orders_to_pay_array = this.join_results;
  
                             // now reset the grid of work orders
          this.work_orders = this.payments_search_results;
  
          },
          error => {
          console.log('Error Loading !' + error.error);
          // console.log(error);
          // return Observable.throw(error);
          }
          );
           
  
            }
  


    getBrandsComboBoxAgents(search_model) {
      this.search_model.brand_type_id = 3;
     this._demoService.getBrandsComboBox(search_model).subscribe(
        data => { this.brands_agent = data; },
        err => console.error(err),
        // () => console.log('done loading Trace Types')
      );
     }



getWorkOrderStatusAll(){
this._demoService.getWorkOrderStatusAll().subscribe(
(data) => {
  this.work_order_status_all = data;
  let res = data[0];
},
(err) => console.error(err),
// () => console.log('Brand Loaded.')
);
}


getWorkOrderPaymentStatusAll(){
this._demoService.getWorkOrderPaymentStatusAll().subscribe(
(data) => {
  this.work_order_payment_status_all = data;
  let res = data[0];
},
(err) => console.error(err),
// () => console.log('Brand Loaded.')
);
}



getWorkOrderCommunicationStatusAll(){
this._demoService.getWorkOrderCommunicationStatusAll().subscribe(
(data) => {
  this.work_order_communication_status_all = data;
  let res = data[0];
},
(err) => console.error(err),
// () => console.log('Brand Loaded.')
);
}











    // Setup the SyncFusion GRID

    rowSelected(args: RowSelectEventArgs) {
      // this.toastr.info( ' Clicked '); 

      // console.log('selected data object: ' + JSON.stringify(args.data));
             // simply push the object/s seleceted to the  this.search_results array.
            //  if(!this.search_results){this.search_results = [];}; // set so is defined before push if empty
            //  this.search_results.push({
            //    ...args.data
            //  });
            // if (typeof args.data === 'object' && args.data !== null && args.data[0].invoice_id >= 0 ){
            //   console.log('We have a header object of data selected');
            // }
    
            //checks if single object
            if (typeof args.data === 'object' && args.data !== null && !args.data[0] ){
                    if(!this.search_results){this.search_results = [];}; // detect if array exists.
                    console.log('We have a single object of data selected');
                      this.search_results.push({
                      ...args.data
                      });

                      // setTimeout(() => {   }, 299);
                      //   console.log("A Simple Pause! OnChanges 1");

                      // payment widget
                      // this.cIBP.pushInvoiceToPay(args.data)
                      this._WorkOrderBulkPaymentWidgetComponent.pushWorkOrderToPay(args.data)
                  // this.toastr.info( this.search_results.length + ' Clicked added to search results'); 

                       
            }
    
            // if an a list of objects need to count and then loop through.
            if (typeof args.data === 'object' && args.data !== null && args.data[0] ){
                    console.log('We have a OBJECT of object of data selected');
                    const count_selected = this.grid.getSelectedRecords().length;
                    console.log('count: ' + count_selected); // lenth is used for myob comparitor array
                    const length = Object.keys(args.data).length
                    console.log('length: ' + length);
                  
                    // now loop and insert individually
                    if(!this.search_results){this.search_results = [];}; // detect if array exists.
                    for(let i=0;i < length; i++) {
                      this.search_results.push({
                      ...args.data[i]
                      });

                      // setTimeout(() => {   }, 299);
                      //   console.log("A Simple Pause! OnChanges 2");
                      // payment widget
                              //  this.cIBP.pushInvoiceToPay(args.data[i]) 
                      this._WorkOrderBulkPaymentWidgetComponent.pushWorkOrderToPay(args.data[i])
                          

                      }
             
                    //  this.toastr.info( this.search_results.length + ' Clicked added to search results');
              }
    
    
    
      const selectedrowindex: number[] = this.grid.getSelectedRowIndexes();  // Get the selected row indexes.
      // alert(selectedrowindex); // To alert the selected row indexes.
      const selectedrecords: object[] = this.grid.getSelectedRecords();  // Get the selected records.
      this.selectedrecords = this.grid.getSelectedRecords();

   
    
    
      }



    rowSelected_2(args: RowSelectEventArgs) {
      // this.toastr.info( ' Clicked '); 

      // console.log('selected data object: ' + JSON.stringify(args.data));
             // simply push the object/s seleceted to the  this.search_results array.
            //  if(!this.search_results){this.search_results = [];}; // set so is defined before push if empty
            //  this.search_results.push({
            //    ...args.data
            //  });
            // if (typeof args.data === 'object' && args.data !== null && args.data[0].invoice_id >= 0 ){
            //   console.log('We have a header object of data selected');
            // }
    
            //checks if single object
            if (typeof args.data === 'object' && args.data !== null && !args.data[0] ){
                    if(!this.search_results){this.search_results = [];}; // detect if array exists.
                    console.log('We have a single object of data selected');
                      this.search_results.push({
                      ...args.data
                      });

                      // setTimeout(() => {   }, 299);
                      //   console.log("A Simple Pause! OnChanges 1");

                      // payment widget
                      // this.cIBP.pushInvoiceToPay(args.data)
     // this._WorkOrderBulkPaymentWidgetComponent.pushWorkOrderToPay(args.data)
                  // this.toastr.info( this.search_results.length + ' Clicked added to search results'); 



                  // new way
                   this._WorkOrderBulkPaymentWidgetComponent.refreshWorkOrdersToPay(this.search_results);



                       
            }
    
            // if an a list of objects need to count and then loop through.
            if (typeof args.data === 'object' && args.data !== null && args.data[0] ){
                    console.log('We have a OBJECT of object of data selected');
                    const count_selected = this.grid.getSelectedRecords().length;
                    console.log('count: ' + count_selected); // lenth is used for myob comparitor array
                    const length = Object.keys(args.data).length
                    console.log('length: ' + length);
                  
                    // now loop and insert individually
                    if(!this.search_results){this.search_results = [];}; // detect if array exists.
                    for(let i=0;i < length; i++) {
                      this.search_results.push({
                      ...args.data[i]
                      });

                      // setTimeout(() => {   }, 299);
                      //   console.log("A Simple Pause! OnChanges 2");
                      // payment widget
                              //  this.cIBP.pushInvoiceToPay(args.data[i]) 
          // this._WorkOrderBulkPaymentWidgetComponent.pushWorkOrderToPay(args.data[i])
                          
                  // new way
                   this._WorkOrderBulkPaymentWidgetComponent.refreshWorkOrdersToPay(this.search_results);



                      }
             
                    //  this.toastr.info( this.search_results.length + ' Clicked added to search results');
              }
    
    
    
      const selectedrowindex: number[] = this.grid.getSelectedRowIndexes();  // Get the selected row indexes.
      // alert(selectedrowindex); // To alert the selected row indexes.
      const selectedrecords: object[] = this.grid.getSelectedRecords();  // Get the selected records.
      this.selectedrecords = this.grid.getSelectedRecords();

   
    
    
      }


    
    
    
                  // we also need to create a row deselect event to remove from args
                  rowDeSelected(args: RowSelectEventArgs) {
          
                    
                    const selectedrowindex: number[] = this.grid.getSelectedRowIndexes();  // Get the selected row indexes.
                    // alert(selectedrowindex); // To alert the selected row indexes.
                    const selectedrecords: object[] = this.grid.getSelectedRecords();  // Get the selected records.
                    this.selectedrecords = this.grid.getSelectedRecords();
          
                    // console.log('selected data object: ' + JSON.stringify(args.data));
                          //  // simply push the object/s seleceted to the  this.search_results array.
                        //    if(!this.search_results){this.search_results = [];}; // set so is defined before push if empty
                        //  // clear the the search results. forst then re-add.
                        //  this.search_results = [];
                        //    this.search_results.push({
                        //      ...args.data
                        //    });
           
                        let argData = args.data;
                    if (typeof argData === 'object' && argData !== null && !argData[0] && argData !== '[]' ){
                      console.log('We have a single object of data de-selected');
                      let base_search_results = this.search_results
                      
                      // this.search_results = []; 
                      // this.search_results.push({
                      //   ...args.data
                      //   });
                      
           
          
                        // leave items where not selected --- somehow add the ones that were already clicked before they all were removed.
                        this.search_results =  this.search_results.filter(function (order) {
                          // return true for salary greater than equals to 25000
                          console.log('leaving IDs= ' + args.data['work_order_id'] + ' != ' + order.work_order_id);
                          return order.work_order_id != args.data['work_order_id'];
                        });
                                    // payment wizard remove from below component
                                          //  this.rowDeselected.emit(args.data['work_order_id'])

                                    // setTimeout(() => {    }, 299);
                                    //   console.log("A Simple Pause! OnChanges 1");
                                        // payment widget
                                      // this._WorkOrderBulkPaymentWidgetComponent.deleteWorkOrderToPayItem(args.data['work_order_id'])
                                              
                          // new way
                   this._WorkOrderBulkPaymentWidgetComponent.refreshWorkOrdersToPay(this.search_results);


                        // this.toastr.warning( ' Order Remved from the action list'); 
           
          
                    // remove
                    // filter and remove the selected ones from the object first.
                        // let remove_unselected = this.comparitor_grid.getSelectedRowIndexes();
                        // // let uniqueArray = this.search_results.filter((v,i,a)=>a.findIndex(t=>(t.id === remove_unselected))===i);
                      
                    }    
          
          
                    // if an a list of objects need to count and then loop through.
                    if (typeof args.data === 'object' && args.data !== null && args.data[0] ){
                      console.log('We have a OBJECT of object of data DE-selected');
                      const count_selected = this.grid.getSelectedRecords().length;
                      console.log('count: ' + count_selected); // both count methods work.
                      // const length = Object.keys(args.data).length
                      // console.log('length: ' + length);
                    
                      // now loop and insert individually
                 //     this.search_results = []; 
                      for(let i=0;i < count_selected; i++) {
                        // for(let i=0;i < count_selected; i++) { // made i 1 because was alwsays missing one
                      //   this.search_results.push({
                      //  ...args.data[i]
                      //   });
          
                        // leave items where not selected 
                            // this.search_results =  this.search_results.filter(function (order) {
                            // // return true for salary greater than equals to 25000
                            // console.log('leaving IDs= ' + args.data['i'].id + ' != ' + order.id);
                            // return order.id != args.data['id'];
                            // });
                            // this.search_results = this.search_results;
          
                                         // leave items where not selected --- somehow add the ones that were already clicked before they all were removed.
                        this.search_results =  this.search_results.filter(function (order) {
                          // return true for salary greater than equals to 25000
                          console.log('leaving IDs= ' + args.data[i]['work_order_id'] + ' != ' + order.work_order_id);
                          return order.work_order_id != args.data[i]['work_order_id'];
                        });


                           // payment wizard remove from below component
                                   // this.rowDeselected.emit(args.data[i]['work_order_id'])


                          //  setTimeout(() => {  }, 299);
                          //   console.log("A Simple Pause! OnChanges 1");
                              // payment widget
                              // this._WorkOrderBulkPaymentWidgetComponent.deleteWorkOrderToPayItem(args.data[i]['work_order_id'])
                                      


                             
                              // this.search_results = '[]'
                              //  this._WorkOrderBulkPaymentWidgetComponent.refreshWorkOrdersToPay(this.search_results); /// seee if this works for the top header. always leaving
                       
          
                        }
          
                        this._WorkOrderBulkPaymentWidgetComponent.refreshWorkOrdersToPay(this.search_results);
                        // this.toastr.warning( ' Remved from the action list'); 
                    
                      }
          
                
          
                  
                    }
    






                  rowDeSelected_orig(args: RowSelectEventArgs) {
          
                    
                    const selectedrowindex: number[] = this.grid.getSelectedRowIndexes();  // Get the selected row indexes.
                    // alert(selectedrowindex); // To alert the selected row indexes.
                    const selectedrecords: object[] = this.grid.getSelectedRecords();  // Get the selected records.
                    this.selectedrecords = this.grid.getSelectedRecords();
          
                    // console.log('selected data object: ' + JSON.stringify(args.data));
                          //  // simply push the object/s seleceted to the  this.search_results array.
                        //    if(!this.search_results){this.search_results = [];}; // set so is defined before push if empty
                        //  // clear the the search results. forst then re-add.
                        //  this.search_results = [];
                        //    this.search_results.push({
                        //      ...args.data
                        //    });
           
                        let argData = args.data;
                    if (typeof argData === 'object' && argData !== null && !argData[0] && argData !== '[]' ){
                      console.log('We have a single object of data de-selected');
                      let base_search_results = this.search_results
                      
                      // this.search_results = []; 
                      // this.search_results.push({
                      //   ...args.data
                      //   });
                      
           
          
                        // leave items where not selected --- somehow add the ones that were already clicked before they all were removed.
                        this.search_results =  this.search_results.filter(function (order) {
                          // return true for salary greater than equals to 25000
                          console.log('leaving IDs= ' + args.data['work_order_id'] + ' != ' + order.work_order_id);
                          return order.work_order_id != args.data['work_order_id'];
                        });
                                    // payment wizard remove from below component
                                          //  this.rowDeselected.emit(args.data['work_order_id'])

                                    // setTimeout(() => {    }, 299);
                                    //   console.log("A Simple Pause! OnChanges 1");
                                        // payment widget
                                      this._WorkOrderBulkPaymentWidgetComponent.deleteWorkOrderToPayItem(args.data['work_order_id'])
                                              
                                  

                        // this.toastr.warning( ' Order Remved from the action list'); 
           
          
                    // remove
                    // filter and remove the selected ones from the object first.
                        // let remove_unselected = this.comparitor_grid.getSelectedRowIndexes();
                        // // let uniqueArray = this.search_results.filter((v,i,a)=>a.findIndex(t=>(t.id === remove_unselected))===i);
                      
                    }    
          
          
                    // if an a list of objects need to count and then loop through.
                    if (typeof args.data === 'object' && args.data !== null && args.data[0] ){
                      console.log('We have a OBJECT of object of data DE-selected');
                      const count_selected = this.grid.getSelectedRecords().length;
                      console.log('count: ' + count_selected); // both count methods work.
                      // const length = Object.keys(args.data).length
                      // console.log('length: ' + length);
                    
                      // now loop and insert individually
                 //     this.search_results = []; 
                      for(let i=0;i < count_selected; i++) {
                        // for(let i=0;i < count_selected; i++) { // made i 1 because was alwsays missing one
                      //   this.search_results.push({
                      //  ...args.data[i]
                      //   });
          
                        // leave items where not selected 
                            // this.search_results =  this.search_results.filter(function (order) {
                            // // return true for salary greater than equals to 25000
                            // console.log('leaving IDs= ' + args.data['i'].id + ' != ' + order.id);
                            // return order.id != args.data['id'];
                            // });
                            // this.search_results = this.search_results;
          
                                         // leave items where not selected --- somehow add the ones that were already clicked before they all were removed.
                        this.search_results =  this.search_results.filter(function (order) {
                          // return true for salary greater than equals to 25000
                          console.log('leaving IDs= ' + args.data[i]['work_order_id'] + ' != ' + order.work_order_id);
                          return order.work_order_id != args.data[i]['work_order_id'];
                        });


                           // payment wizard remove from below component
                                   // this.rowDeselected.emit(args.data[i]['work_order_id'])


                          //  setTimeout(() => {  }, 299);
                          //   console.log("A Simple Pause! OnChanges 1");
                              // payment widget
                              this._WorkOrderBulkPaymentWidgetComponent.deleteWorkOrderToPayItem(args.data[i]['work_order_id'])
                                      
                            
                       
          
                        }
          
                      
                        // this.toastr.warning( ' Remved from the action list'); 
                    
                      }
          
          
                  
                    }






                    selectAllSearchResults(){
                      this.search_results = this.work_orders
                      this.toastr.info('Selecting All in Actions list.')

                    }

    
                    clearSearchResults(){
                      this.search_results = [];
                      // this.comparitor_array_A = [];
                      this.toastr.info('Clearing All in Actions list.')
                    }












  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
        this.grid.excelExport();
    }
  }
  rowDataBound(args: RowDataBoundEventArgs) {
    const job_status = 'payment_status';
    if (args.data[job_status] === 'OVERDUE') {
        args.row.className = 'text-danger';
    }
  }
  
  
  jobLink(job_id) {
    this.router.navigate(['/admin/jobs/create-job-3/' + job_id + '']);
  }
  
  jobView(job_id) {
    this.router.navigate(['/admin/jobs/view/' + job_id + '']);
  }
  
  subjectEdit(subject_id){
    this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
  }
  
  
  refreshGrid(){ // refresh the databutton
   // this.getBrandJobsTableDataGrid(this.brand_id, this.job_status_code, this.assigned_agent);
  //  this.getInvoices();
    this.grid.refresh();
    this.search_results = [];
    this._WorkOrderBulkPaymentWidgetComponent.refreshWorkOrdersToPay(this.search_results);
  };
  
  
  
  
  getInvoices() {
    this._demoService.getInvoices().subscribe(
       data => { this.invoices = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getSubjectInvoices(subject_id) {
    this._demoService.getSubjectInvoices(subject_id).subscribe(
       data => { this.invoices = data; }, // make the same data call for all
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getBrandInvoices(to_brand_id) {
    this._demoService.getBrandInvoices(to_brand_id).subscribe(
       data => { this.invoices = data; 
        // maps to interface.(invoice_mode)
      this.invoice_model = this.invoices;
      
      }, // make the same data call for all
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getBrandWorkOrders(agent_id) {

    if (this.gfunc.sessionBrandTypeId == 1){
    this._demoService.getBrandWorkOrders(agent_id).subscribe(
       data => { this.work_orders = data; 
        // maps to interface.(invoice_mode)
      this.work_order_model = this.work_orders;
      
      }, // make the same data call for all
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
    } // end if staff

    if (this.gfunc.sessionBrandTypeId == 3){
      this._demoService.getBrandWorkOrdersAgentOnly(agent_id).subscribe(
        data => { this.work_orders = data; 
         // maps to interface.(invoice_mode)
       this.work_order_model = this.work_orders;
       
       }, // make the same data call for all
        err => console.error(err),
        // () => console.log('done loading Trace Types')
      );
    }

   }


  
  getBrandJobsTableData(brand_id) {
    this._demoService.getBrandJobsTableData(brand_id).subscribe(
      data => { this.subjects_urgent = data;
        this.open_jobs_count = this.subjects_urgent.length;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent = DataUtil.parse.parseJson(data); 
       // console.log("Done loadng USER");
       // console.log(this.users);
  
  
      },
      error => {
      //  console.error('Error Loading User!');
      // return Observable.throw(error);
      }
    ); }
  
    getBrandJobsTableDataGrid(brand_id, job_status_code, assigned_agent) {
      this._demoService.getBrandJobsTableDataGrid(brand_id, job_status_code, assigned_agent).subscribe(
        data => { this.subjects_urgent = data;
  
        let res = data;
  
          // removes all words with length of > 6
         // const result = this.subjects_urgent.filter(word => this.subjects_urgent.length > 6);
  
         if (this.gfunc.sessionUserLevel === '9' ) { //client - remove these columns
         // let result_filter = this.subjects_urgent.filter(subject => this.subjects_urgent.job_type_id);
         // res.filter( e => this.subjects_urgent.allocated_to);
         // send results back to array.
        // this.subjects_urgent = result_filter;
         }
  
  
          this.open_jobs_count = this.subjects_urgent.length;
          // pass so that the dates are correct in Sync
          // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
          this.subjects_urgent = DataUtil.parse.parseJson(data); 
         // console.log("Done loadng USER");
         // console.log(this.users);
    
    
        },
        error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
        }
      ); }
  
  
  
  // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
  clickHandler(args: ClickEventArgs): void {
    if (args.item.id === 'Click') {
  
    //  this.grid.showSpinner();
  
    //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
   //  console.log(args.data.items);
   
  
  
    let pdfdata;
    const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
    for (let i = 0; i < query.queries.length; i++) {
      if (query.queries[i].fn === 'onPage') {
        query.queries.splice(i, 1);       // remove page query to get all records
        break;
      }
    }
    const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
      pdfdata = e.result as object[];  // get all filtered records
      const exportProperties = {
        dataSource: pdfdata,
      };
      //console.log(pdfdata.results);
      
     // this.search_results = pdfdata.records; // need this if a grouping is set.
    /*   this.search_results = pdfdata;
      this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
      this.toastr.success( "Press Start To Process Que");  */
     // this.grid.pdfExport(exportProperties);
    }).catch((e) => true);
    }
  
   //  this.grid.hideSpinner();
  
  };
  
  
  
  
  // End Grid Items and Setup
  
  
  
  
  
  
  
    
   // MODAL
  // start of modal windows service as a template
  openModal(template: TemplateRef<any>) {
    // small upgrade to disable background click on open modal background
    const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
    this.modalRef = this.modalService.show(template, config);
  }
  
  // :: Parent / Child modal test
  closeParentModel() {
    // alert('parent component function.');
    this.modalRef.hide();
   // this.refreshGrid(); // resets the grid if updated and closed.
  //  this.updateTypeClick = false; // closes the div
  };
  
  
   getBrand(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
    data => { this.brand = data;
    let  res = data;
    this.brandData = res;
    },
     err => console.error(err),
     () => console.log('Brand Loaded.')
   );
  }
  
  
  
  // :: Sart of myob
  
  
  // delay function
  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }
  
  
  // Get Invoice Items
  getInvoiceItmes(invoice_id, model){
    this._demoService.getSubjectInvoiceItems(invoice_id).subscribe(
      (data) => {
        this.invoiceItemsList = data;
        let res = data[0];
        this.invoice_item_model = this.invoiceItemsList;
        this.setMyobInvoiceModelStep2(model); // ru
       
        // this.doCalculations();
      },
      (err) => console.error(err),
     () => console.log('Invoice Items Loaded.')
    )};
  
  
  
    setMyobInvoiceModelStep1(model){
  // this.invoice_item_model = null;
  this.getInvoiceItmes(model.invoice_id, model);
        // (async () => {
  
        //   await this.delay(8000);
        //  })(); // end async function
  
    };
  
  
  // :: Create Invoice.
  // Run this to Create An Invoice as first Step of Process of Functions
  setMyobInvoiceModelStep2(model){
       // Lookup invoice items with delay
       
        // (async () => {
      // Need to lookup/brand customer details as well.
  
  
  
    //   var promise = new Promise<void>((resolve, reject) => {
    //     setTimeout(() => {
    //       this.getInvoiceItmes(model.invoice_id);
    //       console.log("Async Work Complete");
    //       resolve();
    //     }, 1000);
    //   });
    // promise;
  
  
      this._demoService.getBrandById(model.to_brand_id).subscribe(
        data => { this.brand = data;
        const  res = data[0];
                          this.brandData = res;
                    console.log('Brand MyobID: ' + res.myob_id);
                    console.log('Brand ID MYOB: ' + this.brandData.myob_id);
                    console.log('Invoice Items: ' + JSON.stringify(this.invoice_item_model));
                    // Invoice Model.- use return so that model is available in the outside subscription
                   
  // Meed to get a model of the Tax Code ID
  // Memo if a subject or job invoice
  let JournalMemo;
  if (model.is_job_invoice >= 1) {
    JournalMemo = 'Job Invoice';
  }else{
    JournalMemo = 'Subject Invoice';
  };
  
  let BillDeliveryStatus;
  if (model.invoice_communication_status_id === 1) { // email
    BillDeliveryStatus = 'Nothing';
  }else{
    BillDeliveryStatus = 'Print';
  }
  
                    this.data_invoice = {
                    'Number': model.invoice_number, //  model.invoice_number
                    'Date': model.date_created,
                    'SupplierInvoiceNumber': null,
                    'Customer': {
                    'UID': this.brandData.myob_id
                    },
                    'ShipToAddress': '' ,
                    'Terms': {
                    'PaymentIsDue': 'DayOfMonthAfterEOM',
                    'DiscountDate': 1,
                    'BalanceDueDate': 30,
                    'DiscountForEarlyPayment': 0,
                    'MonthlyChargeForLatePayment': 0,
                    'DiscountExpiryDate': model.due_date,
                    'Discount': 0,
                    'DueDate': model.due_date
                    },
                    'IsTaxInclusive': true,
                    'IsReportable': true,
  
                    'Lines': [
                    // {
                    // 'Type': '',
                    // 'Description': '' ,
                    // 'Account': {
                    // 'UID': 'd92626b4-1cbb-4ac9-8b46-856175f5c0a7'
                    // },
                    // 'Total': 6,
                    // 'Job': null,
                    // 'TaxCode': {
                    // 'UID': '8d273078-fe1d-4c16-b318-ec7a2b7fb2fe'
                    // }
                    // },
                    ],
  
                    'Subtotal': model.invoice_subtotal,
                    'Freight': 0,
                    'FreightTaxCode': {
                    // 'UID': '8d273078-fe1d-4c16-b318-ec7a2b7fb2fe'
                    'UID': this.gfunc.myob_FreightTaxCode
                    
                    },
                    'TotalTax': model.invoice_gst,
                    'TotalAmount': model.invoice_total,
                    'Category': null,
                    'Comment': '',
                    'ShippingMethod': null,
                    'PromisedDate': null,
                    'JournalMemo': 'SOP: ' + JournalMemo + ' ' + model.invoice_number,
                    'BillDeliveryStatus': BillDeliveryStatus,
                    'AppliedToDate': 0,
                    'BalanceDueAmount': model.invoice_remaining_total,
                    'Status': 'Open',
                    'LastPaymentDate': null,
                    'Order': null,
                    'ForeignCurrency': null
                    };
  
  
  
                        // :: This function Collects and pushes the lines to the rows of the invoice.
                    // console.log('Invoice Items: 2 ' + JSON.stringify(this.invoiceItemsList));
                    // need to loop through the invoice model and create Lines.
  
  
  
                    let newArr = Object(this.invoice_item_model).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
  
                    let  count_of_items = Object.keys(newArr).length;
                    //  let res = data[0];
                    // Run the job data queries.
                    // need to do a loop of subject_billing items (.length)
                    for(let i=0;i < count_of_items; i++) {
                      let res = newArr[i];
  
  
      // get a list of all the account ID/s in an array  -- THIS WORKS SO WELL!!!!!!
                    // this.getMyobTaxCodes(); // load this onInit.
                    // this.getMyobAccountCodes();
   const retTaxCodeUID = Object(this.myob_tax_codes).filter((mtc)=>(mtc.myob_tax_code_id === res.myob_tax_code_id ));
   const retAccountUID = Object(this.myob_account_codes).filter((mac)=>(mac.myob_account_code_id === res.myob_account_code_id ));
  // console.log('Tax Acc: ' + JSON.stringify(retTaxCodeUID));
  // console.log('Myob Acc: ' + JSON.stringify(retAccountUID));
  

  // Update to warn why invoice not syncing if tax code and account code are incorrect. feb 2023
  if(!retTaxCodeUID[0]){this.toastr.error('TaxCodes Do Not Match items with Account Settings. Please Match your Billing Items with Myob Tax and Account Codes and update this invoice to continue. Delete Items and Billing Tasks before trying to push this invoice again.'); return;}
  if(!retAccountUID[0]){this.toastr.error('Account Codes Do Not Match items with Account Settings. Please Match your Billing Items with Myob Tax and Account Codes and update this invoice to continue. Delete Items and Billing Tasks before trying to push this invoice again.'); return;}


  let TaxAccountUID = retTaxCodeUID[0].UID;
  let MyobAccountUID = retAccountUID[0].UID;
  
  console.log('Tax Code: ' + retTaxCodeUID[0].UID);
  console.log('Acc Code: ' + retAccountUID[0].UID);
  
  
                      let new_line = {
                        // 'RowID': res.invoice_item_id, // see if this works then I can  upate easier. /// no this failed.
                        'Type': 'Transaction',
                        'Description': res.billing_task_name,
                        'Account': {
                        'UID': MyobAccountUID,
                        },
                        'Total': res.total,
                        'Job': null,
                        'TaxCode': {
                        'UID': TaxAccountUID
                        }
                        };
  
                    this.data_invoice.Lines.push(new_line);
                    }
  
                    console.log('New Pushed Model: ' + JSON.stringify(this.data_invoice));
  
  
        },
        err => console.error(err),
        () =>  {
          console.log('invoice model Loaded.');
        this.createMyobInvoiceModel(model, this.data_invoice);
        }
      );
       
        //   await this.delay(3000);
        //  })(); // end async function
  
        /// PUT DOUBLE FUNCTION ON BUTTON AS IT WAS NOT RUNNINT CORRCTly - now a process of three functions.
         // Loads first so that the rest of the subscription can run.
      // this.getInvoiceItmes(model.invoice_id);
  
  }
  
  
  getMyobAccountCodes() {
    this._demoService.getMyobAccountCodes().subscribe(
       data => { this.myob_account_codes = data;
        let res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getMyobTaxCodes() {
    this._demoService.getMyobTaxCodes().subscribe(
       data => { this.myob_tax_codes = data;
        let res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
  createMyobInvoiceModel(model, data_invoice){
    if (confirm('We are about to Sync this Invoice with MYOB, Are you Sure?')) {
  // console.log('Invoice Data: ' + JSON.stringify(data_invoice));
  
  // :: Ideally need to get a response from insert of the UID of the customer to insert back in sop brands to know th e link has taken place.
  if (this.data_invoice != '{}' ) {
      this._demoService.createMyobInvoice(this.data_invoice).subscribe(
      data => { this.myobInvoiceCreatedData = data;
        let res = data[0];
        let new_data_object = JSON.parse(this.myobInvoiceCreatedData);
  
  
        let location_string = new_data_object.location;
        // get everything after last dash 
        let slug = location_string.split('/').pop(); // 2020
        console.log('UUID slug: ' + slug);
  
                    // model.myob_id = slug;
                    // model.sync_with_myob = 1;
                    // this.updateSubjectInvoice(model);
                    // this.editBrand(model);
                    // this.refreshGrid();
                    // this.toastr.info('Invoice Upgraded In SOP');
  
        // :: Need to lookup myoub get UID/myobid and fill rest of model.vars.
                  // need to pass the brand model here as its updatting the full SOP brand details.
                  this._demoService.getMyobInvoiceMapped(slug, model).subscribe(
                     data4 => {
                      console.log(data4);
                      res = data4[0];
                    // many
                      // this.myobContactListMapped = data.data;
                    //single
                      this.myobInvoiceListMapped = data4;
                    // Set the returned Variables Reququied for Update of a Myob Customer.
                    console.log('UID: ' +  data4.UID);
                    console.log('LastModified: ' + data4.LastModified);
                    console.log('RowVersion: ' + data4.RowVersion);
                    // console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
                    // console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);
  
  
                    // work out the nulls for sub arraryas
                    let CategoryUID;
                    let OrderUID;
                    let SalespersonUID
  
                    if (typeof model.Category === 'undefined' || model.Category === null ) {
                      CategoryUID = null;
                    }else {
                      CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
                    };
                    if (typeof model.Order === 'undefined' || model.Order === null ) {
                      OrderUID = null;
                    }else {
                      OrderUID = model.Category.UID; // can only call if actuall exist in the array!
                    };
                    if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
                      SalespersonUID = null;
                    }else {
                      SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
                    };
  
  
                    this.set_RowVersion = data4.RowVersion;
                    // model.IsIndividual = data4.IsIndividual;
                    // model.SaleLayout = data4.SellingDetails.SaleLayout;
                    // model.InvoiceDelivery = data4.SellingDetails.InvoiceDelivery;
                    // model.TaxCode = data4.SellingDetails.TaxCode.UID;
                    // model.FreightTaxCode = data4.SellingDetails.FreightTaxCode.UID;
                    model.RowVersion = data4.RowVersion;
                    model.myob_array = JSON.stringify(data4);
                    model.myob_id = slug;
                    model.sync_with_myob = 1;
  
  
  // All Additional Myon Invoice Variables
     model.UID = data4.UID;
     model.Number = data4.Number;
     model.Date = data4.Date;
     model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
     model.CustomerUID = data4.Customer.UID;
     model.CustomerName = data4.Customer.Name;
     model.CustomerDisplayID = data4.Customer.DisplayID;
     model.PromisedDate = data4.PromisedDate;
     model.BalanceDueAmount = data4.BalanceDueAmount;
     model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
     model.Status = data4.Status;
     model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
     model.TermsDiscountDate = data4.Terms.DiscountDate;
     model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
     model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
     model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
     model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
     model.TermsDiscount = data4.Terms.Discount;
     model.TermsDueDate = data4.Terms.DueDate;
     model.TermsFinanceCharge = data4.Terms.FinanceCharge;
     model.IsTaxInclusive = data4.IsTaxInclusive;
     model.Subtotal = data4.Subtotal;
     model.SubtotalForeign = data4.SubtotalForeign;
     model.Freight = data4.Freight;
     model.FreightForeign = data4.FreightForeign;
     model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
     model.TotalTax = data4.TotalTax;
     model.TotalTaxForeign = data4.TotalTaxForeign;
     model.TotalAmount = data4.TotalAmount;
     model.TotalAmountForeign = data4.TotalAmountForeign;
     model.CategoryUID = CategoryUID; // var
     model.SalespersonUID = SalespersonUID; // var
     model.Comment = data4.Comment;
     model.ShippingMethod = data4.ShippingMethod;
     model.JournalMemo = data4.JournalMemo;
     model.ReferralSource = data4.ReferralSource;
     model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
     model.LastPaymentDate = data4.LastPaymentDate;
     model.CanApplySurcharge = data4.CanApplySurcharge;
     model.OrderUID = OrderUID; // var
     model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
     model.ForeignCurrency = data4.ForeignCurrency;
     model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
     model.LastModified = data4.LastModified;
     model.URI = data4.URI;
     model.RowVersion = data4.RowVersion;
  
  
  
                    // TOD I NEED TO GET THE LINE ID's and RowVersions to be able to update the Invoice. I THink?
                    // UPDATE the invoice Items RowID, RowVersion and other details.
                        // HERE NOW
  
  
  
                              // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
                              let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                              let  count_of_items = Object.keys(newArr).length;
                              //  let res = data[0];
                              // Run the job data queries.
                              // need to do a loop of subject_billing items (.length)
                              for(let i=0;i < count_of_items; i++) {
                                let res = newArr[i];
  
                              // empty array of invoiceItemsList first
                              this.invoiceItemsList = {};
  
                                let TaxCodeUID;
                                let JobUID;
                                let AccountUID;
                                let TaxCodeCode;
  
                              console.log('TaxCodeUID:' +  res.TaxCode.UID);
  
                              // check for nulls on sub arrays
                              if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
                              TaxCodeUID = null;
                              TaxCodeCode = null;
                              }else {
                              TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
                              TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
                              };
                              if (typeof res.Job === 'undefined' || res.Job === null ) {
                              JobUID = null;
                              }else {
                              JobUID = res.Job.UID; // can only call if actuall exist in the array!
                              };
                              if (typeof res.Account === 'undefined' || res.Account === null ) {
                              AccountUID = null;
                              }else {
                              AccountUID = res.Account.UID; // can only call if actuall exist in the array!
                              };
  
                              this.invoiceItemsList = {
                              RowID: res.RowID,
                              Type: res.Type,
                              Description: res.Description,
                              UnitOfMeasure: res.UnitOfMeasure,
                              UnitCount: res.UnitCount,
                              UnitPrice: res.UnitPrice,
                              UnitPriceForeign: res.UnitPriceForeign,
                              DiscountPercent: res.DiscountPercent,
                              Total: res.Total,
                              TotalForeign: res.TotalForeign,
                              AccountUID: AccountUID, // var
                              JobUID: JobUID, // var
                              TaxCodeUID: TaxCodeUID, // var
                              TaxCodeCode: TaxCodeCode, // var
                              RowVersion: res.RowVersion
                                    };
  
                              console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
                              // this.invoiceItemsList = this.invoiceItemsList;
                              if (this.invoiceItemsList !== '{}') {
                                // we udate each item in the loop that was just inserted.
                              this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
                              };
                              } // End Lines Loop
  
                    // Now run the actual invoice model update.
                    this.updateSubjectInvoice(model);  // updates the invoice
  
                    this.toastr.info('Invoice + Items Vrs Upgraded In SOP');
                    this.refreshGrid();
                  },
                  error => {
                    // console.error('Error saving Event!');
                     this.toastr.error('Error Updating Invoice to Myob Details');
                    console.log(error.error);
                   });
  
  
                  //  model.RowVersion = this.set_RowVersion;
  
  
                    
                      //  model.RowVersion = this.set_RowVersion;
                  //  model.myob_customer_array = JSON.stringify(this.myobContactListMapped);
  
  
        // let new_data_string = JSON.stringify(this.myobCustomerCreatedData);
        // console.log('new_data date: ' + new_data_string.date);
        // console.log('new_data date: ' + new_data_string.location);
  
        // console.log(this.myobCustomerCreatedData.location);
        // // https://www.concretepage.com/questions/577
        //  this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
        //  // console.log(this.arrCase);
        //  this.Items = data['Items'] ;
  
      
      },
      err => {
        // this.toastr.error('You need to login to MYOB again, Connection lost!');
       console.log(err.error);
      },
      // () => console.log('done loading Trace Types')
    );
  }// end if invoice_data
  
    }; // end confirm
  
  };
  
  
  
  updateMyobInvoiceModelStep1(model){
    this.getUpdateInvoiceItmes(model.invoice_id, model);
      };
  
   // Get Invoice Items
  getUpdateInvoiceItmes(invoice_id, model){
    this._demoService.getSubjectInvoiceItems(invoice_id).subscribe(
      (data) => {
        this.invoiceItemsList = data;
        let res = data[0];
        this.invoice_item_model = this.invoiceItemsList;
        // this.setMyobInvoiceModelStep2(model); // ru
        this.updateMyobInvoiceModelStep2(model);
        // this.doCalculations();
      },
      (err) => console.error(err),
     () => console.log('Invoice Items Loaded.')
    )};
  
  
  
    updateMyobInvoiceModelStep2(model){
     this._demoService.getBrandById(model.to_brand_id).subscribe(
       data => { this.brand = data;
       const  res = data[0];
                         this.brandData = res;
                   console.log('Brand MyobID: ' + res.myob_id);
                   console.log('Brand ID MYOB: ' + this.brandData.myob_id);
                   console.log('Invoice Items: ' + JSON.stringify(this.invoice_item_model));
                   // Invoice Model.- use return so that model is available in the outside subscription
                  
  // Memo if a subject or job invoice
  let JournalMemo: string;
  if (model.is_job_invoice >= 1) {
    JournalMemo = 'Job Invoice';
  }else{
    JournalMemo = 'Subject Invoice';
  };
  
  let BillDeliveryStatus: string;
  if (model.invoice_communication_status_id === 1) { // email
    BillDeliveryStatus = 'Nothing';
  }else{
    BillDeliveryStatus = 'Print';
  }
  
  // NEed tp add the extra update records and IDS in model
  
                   this.data_invoice = {
                  'UID': model.UID, // update fields for model 
                  'RowVersion': model.RowVersion, // update
  
                   'Number': model.invoice_number, //  model.invoice_number
                   'Date': model.date_created,
                   'SupplierInvoiceNumber': null,
                   'Customer': {
                   'UID': this.brandData.myob_id
                   },
                   'ShipToAddress': '' ,
                   'Terms': {
                   'PaymentIsDue': 'DayOfMonthAfterEOM',
                   'DiscountDate': 1,
                   'BalanceDueDate': 30,
                   'DiscountForEarlyPayment': 0,
                   'MonthlyChargeForLatePayment': 0,
                   'DiscountExpiryDate': model.due_date,
                   'Discount': 0,
                   'DueDate': model.due_date
                   },
                   'IsTaxInclusive': true,
                   'IsReportable': true,
  
                   'Lines': [
                   // {
                   // 'Type': '',
                   // 'Description': '' ,
                   // 'Account': {
                   // 'UID': 'd92626b4-1cbb-4ac9-8b46-856175f5c0a7'
                   // },
                   // 'Total': 6,
                   // 'Job': null,
                   // 'TaxCode': {
                   // 'UID': '8d273078-fe1d-4c16-b318-ec7a2b7fb2fe'
                   // }
                   // },
                   ],
  
                   'Subtotal': model.invoice_subtotal,
                   'Freight': 0,
                   'FreightTaxCode': {
                   'UID': '8d273078-fe1d-4c16-b318-ec7a2b7fb2fe'
                   },
                   'TotalTax': model.invoice_gst,
                   'TotalAmount': model.invoice_total,
                   'Category': null,
                   'Comment': '',
                   'ShippingMethod': null,
                   'PromisedDate': null,
                   'JournalMemo': 'SOP: ' + JournalMemo + ' ' + model.invoice_number,
                   'BillDeliveryStatus': BillDeliveryStatus,
                   'AppliedToDate': 0,
                   'BalanceDueAmount': model.invoice_remaining_total,
                   'Status': 'Open',
                   'LastPaymentDate': null,
                   'Order': null,
                   'ForeignCurrency': null
                   };
  
  
  
                       // :: This function Collects and pushes the lines to the rows of the invoice.
                   // console.log('Invoice Items: 2 ' + JSON.stringify(this.invoiceItemsList));
                   // need to loop through the invoice model and create Lines.
  
                   let newArr = Object(this.invoice_item_model).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
  
                   let  count_of_items = Object.keys(newArr).length;
                   //  let res = data[0];
                   // Run the job data queries.
                   // need to do a loop of subject_billing items (.length)
                   for(let i=0;i < count_of_items; i++) {
                     let res2 = newArr[i];
  
  
                      // get a list of all the account ID/s in an array  -- THIS WORKS SO WELL!!!!!!
                                    // this.getMyobTaxCodes(); // load this onInit.
                                    // this.getMyobAccountCodes();
                    const retTaxCodeUID = Object(this.myob_tax_codes).filter((mtc)=>(mtc.myob_tax_code_id === res2.myob_tax_code_id ));
                    const retAccountUID = Object(this.myob_account_codes).filter((mac)=>(mac.myob_account_code_id === res2.myob_account_code_id ));
                    // console.log('Tax Acc: ' + JSON.stringify(retTaxCodeUID));
                    // console.log('Myob Acc: ' + JSON.stringify(retAccountUID));
  
                    let TaxAccountUID = retTaxCodeUID[0].UID;
                    let MyobAccountUID = retAccountUID[0].UID;
  
                    console.log('Tax Code: ' + retTaxCodeUID[0].UID);
                    console.log('Acc Code: ' + retAccountUID[0].UID);
  
  
                    //  let new_line = {
                    //    'RowID': res.RowID, // requored update
                    //    'RowVersion': res.RowVersion, // required Update
                    //    'Type': 'Transaction',
                    //    'Description': res.billing_task_name,
                    //    'Account': {
                    //    'UID': MyobAccountUID,
                    //    },
                    //    'Total': res.total,
                    //    'Job': null,
                    //    'TaxCode': {
                    //    'UID': TaxAccountUID
                    //    }
                    //    };
  
                    this.new_line = null; // reset
  
                    // :: Determine to update row or insert new if Lines.RowID exista
  
                    if(res2.RowID != null) {
                    this.new_line = {
                      'RowID': res2.RowID, // requored update
                      'RowVersion': res2.RowVersion, // required Update
                      'Type': 'Transaction',
                      'Description': res2.billing_task_name,
                      'Account': {
                      'UID': MyobAccountUID,
                      },
                      'Total': res2.total,
                      'Job': null,
                      'TaxCode': {
                      'UID':  TaxAccountUID
                      }
                      };
                    }; // end update line
  
                    if (res2.RowID == null) {
                      this.new_line = {
                        // 'RowID': res2.RowID, // requored update
                        // 'RowVersion': res2.RowVersion, // required Update
                        'Type': 'Transaction',
                        'Description': res2.billing_task_name,
                        'Account': {
                        'UID': MyobAccountUID,
                        },
                        'Total': res2.total,
                        'Job': null,
                        'TaxCode': {
                        'UID':  TaxAccountUID
                        }
                        };
                      }; // end new line.
  
  
                   this.data_invoice.Lines.push(this.new_line);
                   }
  
                   console.log('Update Pushed Model: ' + JSON.stringify(this.data_invoice));
  
  
       },
       err => console.error(err),
       () =>  {
         console.log('invoice model Loaded.');
       this.updateMyobInvoiceModel(model, this.data_invoice);
       }
     );
      
       //   await this.delay(3000);
       //  })(); // end async function
  
       /// PUT DOUBLE FUNCTION ON BUTTON AS IT WAS NOT RUNNINT CORRCTly - now a process of three functions.
        // Loads first so that the rest of the subscription can run.
     // this.getInvoiceItmes(model.invoice_id);
  
  }
  
  
  updateMyobInvoiceModel(model, data_invoice) {
    if (confirm('We are about to Sync and Update Invoice data to MYOB, Are you Sure?')) {
      // console.log('Invoice Data: ' + JSON.stringify(data_invoice));
      
      // :: Ideally need to get a response from insert of the UID of the customer to insert back in sop brands to know th e link has taken place.
      if (this.data_invoice != '{}' ) {
          this._demoService.updateMyobInvoice(this.data_invoice).subscribe(
          data => { this.myobInvoiceUpdatedData = data;
            let res = data[0];
            let new_data_object = JSON.parse(this.myobInvoiceUpdatedData);
      
      
            let location_string = new_data_object.location;
            // get everything after last dash 
            let slug = location_string.split('/').pop(); // 2020
            console.log('UUID slug: ' + slug);
      
                        // model.myob_id = slug;
                        // model.sync_with_myob = 1;
                        // this.updateSubjectInvoice(model);
                        // this.editBrand(model);
                        // this.refreshGrid();
                        // this.toastr.info('Invoice Upgraded In SOP');
      
            // :: Need to lookup myoub get UID/myobid and fill rest of model.vars.
                      // need to pass the brand model here as its updatting the full SOP brand details.
                      this._demoService.getMyobInvoiceMapped(slug, model).subscribe(
                         data4 => {
                          console.log(data4);
                          res = data4[0];
                        // many
                          // this.myobContactListMapped = data.data;
                        //single
                          this.myobInvoiceListMapped = data4;
                        // Set the returned Variables Reququied for Update of a Myob Customer.
                        console.log('UID: ' +  data4.UID);
                        console.log('LastModified: ' + data4.LastModified);
                        console.log('RowVersion: ' + data4.RowVersion);
                        // console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
                        // console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);
  
  
                    // work out the nulls for sub arraryas
                    let CategoryUID;
                    let OrderUID;
                    let SalespersonUID
  
                    if (typeof model.Category === 'undefined' || model.Category === null ) {
                      CategoryUID = null;
                    }else {
                      CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
                    };
                    if (typeof model.Order === 'undefined' || model.Order === null ) {
                      OrderUID = null;
                    }else {
                      OrderUID = model.Category.UID; // can only call if actuall exist in the array!
                    };
                    if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
                      SalespersonUID = null;
                    }else {
                      SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
                    };
  
  
  
  
  
                        this.set_RowVersion = data4.RowVersion;
                        // model.IsIndividual = data4.IsIndividual;
                        // model.SaleLayout = data4.SellingDetails.SaleLayout;
                        // model.InvoiceDelivery = data4.SellingDetails.InvoiceDelivery;
                        // model.TaxCode = data4.SellingDetails.TaxCode.UID;
                        // model.FreightTaxCode = data4.SellingDetails.FreightTaxCode.UID;
                        model.RowVersion = data4.RowVersion;
                        model.myob_array = JSON.stringify(data4);
                        model.myob_id = slug;
                        model.sync_with_myob = 1;
      
                        
  
  
  
  // All Additional Myon Invoice Variables
  model.UID = data4.UID;
  model.Number = data4.Number;
  model.Date = data4.Date;
  model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
  model.CustomerUID = data4.Customer.UID;
  model.CustomerName = data4.Customer.Name;
  model.CustomerDisplayID = data4.Customer.DisplayID;
  model.PromisedDate = data4.PromisedDate;
  model.BalanceDueAmount = data4.BalanceDueAmount;
  model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
  model.Status = data4.Status;
  model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
  model.TermsDiscountDate = data4.Terms.DiscountDate;
  model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
  model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
  model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
  model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
  model.TermsDiscount = data4.Terms.Discount;
  model.TermsDueDate = data4.Terms.DueDate;
  model.TermsFinanceCharge = data4.Terms.FinanceCharge;
  model.IsTaxInclusive = data4.IsTaxInclusive;
  model.Subtotal = data4.Subtotal;
  model.SubtotalForeign = data4.SubtotalForeign;
  model.Freight = data4.Freight;
  model.FreightForeign = data4.FreightForeign;
  model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
  model.TotalTax = data4.TotalTax;
  model.TotalTaxForeign = data4.TotalTaxForeign;
  model.TotalAmount = data4.TotalAmount;
  model.TotalAmountForeign = data4.TotalAmountForeign;
  model.CategoryUID = CategoryUID; // var
  model.SalespersonUID = SalespersonUID; // var
  model.Comment = data4.Comment;
  model.ShippingMethod = data4.ShippingMethod;
  model.JournalMemo = data4.JournalMemo;
  model.ReferralSource = data4.ReferralSource;
  model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
  model.LastPaymentDate = data4.LastPaymentDate;
  model.CanApplySurcharge = data4.CanApplySurcharge;
  model.OrderUID = OrderUID; // var
  model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
  model.ForeignCurrency = data4.ForeignCurrency;
  model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
  model.LastModified = data4.LastModified;
  model.URI = data4.URI;
  model.RowVersion = data4.RowVersion;
  
  
  
                 // TOD I NEED TO GET THE LINE ID's and RowVersions to be able to update the Invoice. I THink?
                 // UPDATE the invoice Items RowID, RowVersion and other details.
                     // HERE NOW
  
  
  
                           // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
                           let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                           let  count_of_items = Object.keys(newArr).length;
                           //  let res = data[0];
                           // Run the job data queries.
                           // need to do a loop of subject_billing items (.length)
                           for(let i=0;i < count_of_items; i++) {
                             let res = newArr[i];
  
                           // empty array of invoiceItemsList first
                           this.invoiceItemsList = {};
  
                             let TaxCodeUID;
                             let JobUID;
                             let AccountUID;
                             let TaxCodeCode;
  
                           console.log('TaxCodeUID:' +  res.TaxCode.UID);
  
                           // check for nulls on sub arrays
                           if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
                           TaxCodeUID = null;
                           TaxCodeCode = null;
                           }else {
                           TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
                           TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
                           };
                           if (typeof res.Job === 'undefined' || res.Job === null ) {
                           JobUID = null;
                           }else {
                           JobUID = res.Job.UID; // can only call if actuall exist in the array!
                           };
                           if (typeof res.Account === 'undefined' || res.Account === null ) {
                           AccountUID = null;
                           }else {
                           AccountUID = res.Account.UID; // can only call if actuall exist in the array!
                           };
  
                           // so we can insert new items or remove ones that do not exist.
                           // NEW
                           this.invoiceItemsList = { 
                           RowID: res.RowID,
                           Type: res.Type,
                           Description: res.Description,
                           UnitOfMeasure: res.UnitOfMeasure,
                           UnitCount: res.UnitCount,
                           UnitPrice: res.UnitPrice,
                           UnitPriceForeign: res.UnitPriceForeign,
                           DiscountPercent: res.DiscountPercent,
                           Total: res.Total,
                           TotalForeign: res.TotalForeign,
                           AccountUID: AccountUID, // var
                           JobUID: JobUID, // var
                           TaxCodeUID: TaxCodeUID, // var
                           TaxCodeCode: TaxCodeCode, // var
                           RowVersion: res.RowVersion
                                 };
  
                           console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
                           // this.invoiceItemsList = this.invoiceItemsList;
                           if (this.invoiceItemsList !== '{}') {
                             // we udate each item in the loop that was just inserted.
                           this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
                           };
                           } // End Lines Loop
  
  
  
  
  
                        this.updateSubjectInvoice(model);
                        this.toastr.info('Invoice Upgraded In Myob');
                        this.refreshGrid();
                      },
                      error => {
                        // console.error('Error saving Event!');
                         this.toastr.error('Error Updating Invoice to Myob Details');
                        console.log(error.error);
                       });
      
      
                      //  model.RowVersion = this.set_RowVersion;
      
      
                        
                          //  model.RowVersion = this.set_RowVersion;
                      //  model.myob_customer_array = JSON.stringify(this.myobContactListMapped);
      
      
            // let new_data_string = JSON.stringify(this.myobCustomerCreatedData);
            // console.log('new_data date: ' + new_data_string.date);
            // console.log('new_data date: ' + new_data_string.location);
      
            // console.log(this.myobCustomerCreatedData.location);
            // // https://www.concretepage.com/questions/577
            //  this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
            //  // console.log(this.arrCase);
            //  this.Items = data['Items'] ;
      
          
          },
          err => {
            // this.toastr.error('You need to login to MYOB again, Connection lost!');
           console.log(err.error);
          },
          // () => console.log('done loading Trace Types')
        );
      }// end if invoice_data
      
        }; // end confirm
      
  
  };
  
  
  
  
  
  public getMyobInvoices() {
    this._demoService.getMyobInvoices().subscribe(
      data => { this.myobInvoices = data;
        const res = data[0];
         // https://www.concretepage.com/questions/577
         this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
         // console.log(this.arrCase);
         this.Items = data['Items'] ;
         console.log(this.Items);
        // this.Address = this.Items['Address'];
  // return this.myobCustomers;
  
  // Map the data top the new model system
  // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));
  
      },
      err => {
        // this.toastr.error('You need to login to MYOB again, Connection lost!');
        console.error(err);
      },
      // () => console.log('done loading Trace Types')
    );
  
  }
  
  
  
  
  
  
  
  
  deleteMyobServiceInvoiceModel(model){
    if (confirm('This will delete this Invoice from Myob. We cannot undo this, Are you Sure?')) {
  this._demoService.deleteMyobInvoice(model).subscribe(
      data => { this.myobInvoiceDeleteData = data;
        let res = data[0];
        model.myob_id = null;
        model.sync_with_myob = 0;
        this.updateSubjectInvoice(model);
          this.refreshGrid();
        this.toastr.success('Invoice Deleted from with Myob');
      },
      err => {
        // this.toastr.error('You need to login to MYOB again, Connection lost!');
       // console.error(err);
      },
      // () => console.log('done loading Trace Types')
    );
  
    }; // end confirm
  
  };
  
  
  
  
  
  
  public getMyobInvoice(UID){
    this._demoService.getMyobInvoice(UID).subscribe(
      data => { this.myobInvoice = data;
        let res = data[0];
         this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
         // console.log(this.arrCase);
         this.invoiceItem = data['Item'] ;
        // console.log(this.customerItem);
        // this.Address = this.Items['Address'];
      },
      err => {
        // this.toastr.error('You need to login to MYOB again, Connection lost!');
        console.error(err);
      },
      // () => console.log('done loading')
    );
  }
  
  
  
  
  
  
  
  updateSubjectInvoice(invoice_model){
    this._demoService.updateSubjectInvoice(invoice_model).subscribe(
      data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
        // let res = data[0];
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
    this.toastr.success('Local Invoice Updated');
       return true;
      },
      error => {
        console.log(error.error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
  )
   }
  
  
  
  
   lookupInvoiceUpdateInvoice(UID, model){
  
    this._demoService.getMyobInvoiceMapped(UID, model).subscribe(
      data4 => {
       console.log(data4);
       let res = data4[0];
       this.myobInvoiceListMapped = data4;
     // Set the returned Variables Reququied for Update of a Myob Customer.
    //  console.log('UID: ' +  data4.UID);
    console.log('UID: ' +  data4.UID);
    console.log('retInvoiceModel: ' +  JSON.stringify(data4));
  
  
  
  // work out the nulls for sub arraryas
  let CategoryUID;
  let OrderUID;
  let SalespersonUID
  
  if (typeof model.Category === 'undefined' || model.Category === null ) {
    CategoryUID = null;
  }else {
    CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
  };
  if (typeof model.Order === 'undefined' || model.Order === null ) {
    OrderUID = null;
  }else {
    OrderUID = model.Category.UID; // can only call if actuall exist in the array!
  };
  if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
    SalespersonUID = null;
  }else {
    SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
  };
  
  
    this.set_RowVersion = data4.RowVersion;
    // Local data vars.
     model.myob_customer_array = JSON.stringify(data4);
     model.myob_id = data4.UID;
  
     model.UID = data4.UID;
     model.Number = data4.Number;
     model.Date = data4.Date;
     model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
     model.CustomerUID = data4.Customer.UID;
     model.CustomerName = data4.Customer.Name;
     model.CustomerDisplayID = data4.Customer.DisplayID;
     model.PromisedDate = data4.PromisedDate;
     model.BalanceDueAmount = data4.BalanceDueAmount;
     model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
     model.Status = data4.Status;
     model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
     model.TermsDiscountDate = data4.Terms.DiscountDate;
     model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
     model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
     model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
     model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
     model.TermsDiscount = data4.Terms.Discount;
     model.TermsDueDate = data4.Terms.DueDate;
     model.TermsFinanceCharge = data4.Terms.FinanceCharge;
     model.IsTaxInclusive = data4.IsTaxInclusive;
     model.Subtotal = data4.Subtotal;
     model.SubtotalForeign = data4.SubtotalForeign;
     model.Freight = data4.Freight;
     model.FreightForeign = data4.FreightForeign;
     model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
     model.TotalTax = data4.TotalTax;
     model.TotalTaxForeign = data4.TotalTaxForeign;
     model.TotalAmount = data4.TotalAmount;
     model.TotalAmountForeign = data4.TotalAmountForeign;
     model.CategoryUID = CategoryUID; // var
     model.SalespersonUID = SalespersonUID; // var
     model.Comment = data4.Comment;
     model.ShippingMethod = data4.ShippingMethod;
     model.JournalMemo = data4.JournalMemo;
     model.ReferralSource = data4.ReferralSource;
     model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
     model.LastPaymentDate = data4.LastPaymentDate;
     model.CanApplySurcharge = data4.CanApplySurcharge;
     model.OrderUID = OrderUID; // var
     model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
     model.ForeignCurrency = data4.ForeignCurrency;
     model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
     model.LastModified = data4.LastModified;
     model.URI = data4.URI;
     model.RowVersion = data4.RowVersion;
  
  
    //  this.updateSubjectInvoice(model);
     // update invoice itemes? to do Done BELOW... by description! to set row IDS
  
    // create a lines model with all new data and upate existing invoice_items.
  
  
  // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
    let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
    let  count_of_items = Object.keys(newArr).length;
    //  let res = data[0];
    // Run the job data queries.
    // need to do a loop of subject_billing items (.length)
    for(let i=0;i < count_of_items; i++) {
      let res = newArr[i];
  
    // empty array of invoiceItemsList first
    this.invoiceItemsList = {};
  
      let TaxCodeUID;
      let JobUID;
      let AccountUID;
      let TaxCodeCode;
  
  console.log('TaxCodeUID:' +  res.TaxCode.UID);
  
  // check for nulls on sub arrays
  if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
    TaxCodeUID = null;
    TaxCodeCode = null;
  }else {
    TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
    TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
  };
  if (typeof res.Job === 'undefined' || res.Job === null ) {
    JobUID = null;
  }else {
    JobUID = res.Job.UID; // can only call if actuall exist in the array!
  };
  if (typeof res.Account === 'undefined' || res.Account === null ) {
    AccountUID = null;
  }else {
    AccountUID = res.Account.UID; // can only call if actuall exist in the array!
  };
  
  this.invoiceItemsList = {
    RowID: res.RowID,
    Type: res.Type,
    Description: res.Description,
    UnitOfMeasure: res.UnitOfMeasure,
    UnitCount: res.UnitCount,
    UnitPrice: res.UnitPrice,
    UnitPriceForeign: res.UnitPriceForeign,
    DiscountPercent: res.DiscountPercent,
    Total: res.Total,
    TotalForeign: res.TotalForeign,
    AccountUID: AccountUID, // var
    JobUID: JobUID, // var
    TaxCodeUID: TaxCodeUID, // var
    TaxCodeCode: TaxCodeCode, // var
    RowVersion: res.RowVersion
          };
    
    console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
    // this.invoiceItemsList = this.invoiceItemsList;
    if (this.invoiceItemsList !== '{}') {
    this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
    };
    } // End Lines Loop
  
  
     this.toastr.info('Invoice Vrs Updated In SOP');
     // now finally update the invoice
     this.updateSubjectInvoice(model);
        this.refreshGrid();
   },
   error => {
     // console.error('Error saving Event!');
      this.toastr.error('Error Collecting Invoice Myob Details');
     console.log(error.error);
    });
  }; // end loopup and update function
  
  
  
  
   // Get Invoice Items - Normal get
   getInvoiceItems(invoice_id){
    this._demoService.getSubjectInvoiceItems(invoice_id).subscribe(
      (data) => {
        this.invoiceItemsList = data;
        let res = data[0];
        this.invoice_item_model = this.invoiceItemsList;
        // this.setMyobInvoiceModelStep2(model); // ru
        // this.updateMyobInvoiceModelStep2(model);
        // this.doCalculations();
      },
      (err) => console.error(err),
     () => console.log('Invoice Items Loaded.')
    )};
  
  
  
    updateSubjectInvoiceItem(model, invoice_id){
      this._demoService.updateSubjectInvoiceItemByDescription(model, invoice_id).subscribe(
        data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
          // let res = data[0];
        // this.router.navigate(['../../companies'], { relativeTo: this.route });
         return true;
        },
        error => {
          console.error(error);
       //  this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
        }
    )
     }
  
  
  editBrand(model){
    // model.job_id = this.job_id;
     this._demoService.updateBrand(model).subscribe(
       data => {  // this.trace_candidate_update = data;
         // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
       this.toastr.success('Company Updated');
       this.gfunc.insertLog_UpdateCompany(model); // hadled in the global functions file.
      // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
      // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error Updating Brand');
        return console.log(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
   );}
  
  
  
  
  }